var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.9 0 6 0.9 6 2V30C6 31.1 6.9 32 8 32H28C29.1 32 30 31.1 30 30V8L22 0H8Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H30L22 0V6C22 7.1 22.9 8 24 8Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14L24 8H30V14Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26C26 26.55 25.55 27 25 27H3C2.45 27 2 26.55 2 26V16C2 15.45 2.45 15 3 15H25C25.55 15 26 15.45 26 16V26Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87306 18.947C8.87306 18.275 9.92906 18.275 9.92906 18.947V22.105C9.92906 23.361 9.32906 24.121 7.94606 24.121C7.26606 24.121 6.69906 23.936 6.20306 23.297C5.79506 22.809 6.56306 22.106 6.97906 22.617C7.31506 23.033 7.67506 23.129 8.02606 23.113C8.47306 23.097 8.86606 22.896 8.87406 22.105V18.947H8.87306Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 18.9469C11.334 18.6829 11.542 18.3949 11.878 18.3949H13.725C14.765 18.3949 15.701 19.0909 15.701 20.4249C15.701 21.6889 14.765 22.3929 13.725 22.3929H12.39V23.4489C12.39 23.8009 12.166 23.9999 11.878 23.9999C11.614 23.9999 11.334 23.8009 11.334 23.4489V18.9469ZM12.39 19.4019V21.3939H13.725C14.261 21.3939 14.685 20.9209 14.685 20.4249C14.685 19.8659 14.261 19.4019 13.725 19.4019H12.39Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.411 23.385C20.843 23.857 20.147 24.0569 19.444 24.0569C17.764 24.0569 16.573 23.098 16.573 21.194C16.573 19.58 17.829 18.325 19.515 18.325C20.147 18.325 20.842 18.54 21.338 19.028C21.825 19.507 21.122 20.2189 20.643 19.7959C20.347 19.5079 19.931 19.292 19.515 19.292C18.548 19.292 17.613 20.067 17.613 21.194C17.613 22.378 18.396 23.0979 19.444 23.0979C19.931 23.0979 20.347 22.953 20.643 22.738V21.7549H19.444C18.732 21.7549 18.804 20.7789 19.444 20.7789H21.043C21.339 20.7789 21.61 21.0029 21.61 21.2509V22.954C21.61 23.098 21.547 23.232 21.411 23.385Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27H6V28H25C25.55 28 26 27.55 26 27V26C26 26.55 25.55 27 25 27Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/JPG.983fcccea6ad1ab1985a360380b3dc0e.svg";
export { ForwardRef as ReactComponent };